import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { AdvisoryManagementCzechResourcesDictionary } from "AdvisoryManagement/Translations/CzechResourceDictionary";
import { CommissionDistributionCzechResourcesDictionary } from "CommissionDistribution/Translations/CzechResourceDictionary";
import { CzechResourcesDictionary } from "Infrastructure/Translations/CzechResourcesDictionary";
import { TranslationResources } from "Infrastructure/Translations/TranslationResource";

export const initI18n = (callback?: () => void) => {
	i18n
		.use(initReactI18next)
		.init({
			resources: {
				cs: {
					[TranslationResources.Default]: CzechResourcesDictionary,
					[TranslationResources.AdvisoryManagement]:
						AdvisoryManagementCzechResourcesDictionary,
					[TranslationResources.CommissionDistribution]:
						CommissionDistributionCzechResourcesDictionary,
				},
			},
			lng: "cs",
			fallbackLng: "cs",
			interpolation: {
				escapeValue: false,
			},
			ns: [
				TranslationResources.Default,
				TranslationResources.AdvisoryManagement,
				TranslationResources.CommissionDistribution,
			],
			defaultNS: TranslationResources.Default,
		})
		.then(() => {
			callback?.();
		});
};
